import axios from '@/libs/api.request'
import urlObj from '@/config/env.js'

// 提交数据 申请退货(前台)
export function freightdata(data) {
  return axios.request({
    url: urlObj.wss + 'wss-order/sales/after/refund',
    method: 'post',
    data
  })
}

// 退货处理信息 (前台)
export function disfreightInfo(params) {
  return axios.request({
    url: urlObj.wss + `wss-order/afterSale/getAfterSaleOrderById/${params}`,
    method: 'get'
  })
}

//  买家处理退款处理信息 (前台)
export function buyerfreight(params) {
  return axios.request({
    url: urlObj.wss + `wss-order/sales/after/revoke/${params}`,
    method: 'get'
  })
}

// 卖家处理退款处理信息 (前台)
export function sellefreight(params) {
  return axios.request({
    url: urlObj.wss + 'wss-order/afterSale/audit',
    method: 'get',
    params
  })
}


// 获取售后页面的退货退款选项
export function getType(params) {
  return axios.request({
    url: urlObj.wss + 'wss-order/sales/after',
    method: 'get',
    params
  })
}
